var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0V9.44499H9.1296L16.8546 11.4976L8.99642 20.5571V23H0V8.44232L8.48261 0.165536L23 0Z",
    fill: "#EEF2F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 33V23.555H23.0036L15.4537 21.4976L23.0036 12.204V10H32V24.553L23.5174 32.8345L9 33Z",
    fill: "#EEF2F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxImage);
export default __webpack_public_path__ + "static/media/box-image.41fccc28491d2fc4e094be5e939d17b4.svg";
export { ForwardRef as ReactComponent };